import {
  DynamicSectionTypes,
  type TDynamicSection,
} from '@/types/dynamic-sections';

export const sortEnabledSections = (
  sections?: TDynamicSection[],
): TDynamicSection[] => {
  if (!sections || !Array.isArray(sections)) return [];

  return (
    sections
      ?.filter((section) => section?.enabled)
      ?.sort(
        (sectionA, sectionB) => (sectionA.order ?? 0) - (sectionB.order ?? 0),
      ) || []
  );
};

/**
 * Same DYNAMIC_PRODUCTS list for getStaticProps and DynamicSections so SSR
 * shelf payloads stay aligned by array index (not string map keys).
 */
export function listDynamicProductSections(
  sections?: TDynamicSection[],
): TDynamicSection[] {
  return sortEnabledSections(sections).filter(
    (section) => section?.type === DynamicSectionTypes.DYNAMIC_PRODUCTS,
  );
}

/**
 * DOM / Swiper uniqueKey for a shelf. Prefer `id`; otherwise index among
 * `listDynamicProductSections` (not used for SSR product lookup).
 */
export function dynamicProductsSectionKey(
  section: Pick<TDynamicSection, 'id' | 'type' | 'component' | 'order'>,
  indexAmongDynamicProducts: number,
): string {
  const disambiguator = section.id
    ? String(section.id)
    : `i${indexAmongDynamicProducts}`;
  return `${section.type}-${section.component}-${section.order ?? 0}-${disambiguator}`;
}
